import { SyntheticEvent } from 'react';
import BootstrapForm from 'react-bootstrap/Form';
import CheckboxRadio from 'components/common/CheckboxRadio/CheckboxRadio';
import * as K from 'common/constants';

type PieSettingsDropdownProps = {
  pieStyle: string;
  maxPieSlices: number;
  setPieStyle: (pieStyle: string) => void;
  setMaxPieSlices: (maxSlices: number) => void;
};

/**
 * Menu for editing Pie/Donut chart display settings
 */
function PieSettingsMenu({ pieStyle, maxPieSlices, setPieStyle, setMaxPieSlices }: PieSettingsDropdownProps) {
  const formRadios = {
    style: [
      { label: 'Pie', value: K.PIE_CHART_TYPES.PIE },
      { label: 'Donut', value: K.PIE_CHART_TYPES.DONUT },
    ],
  };

  return (
    <div className="GraphDisplaySettings__Body">
      <BootstrapForm.Group className="GraphDisplaySettings__FormGroup">
        <BootstrapForm.Label className="GraphDisplaySettings__FormLabel">Style</BootstrapForm.Label>
        <div>
          {formRadios.style.map((radio, idx) => (
            <CheckboxRadio
              key={`Style-${idx}`}
              type="radio"
              name="Style"
              label={radio.label}
              onChange={() => setPieStyle(radio.value)}
              checked={pieStyle === radio.value}
              value={radio.value}
            />
          ))}
        </div>
      </BootstrapForm.Group>
      <BootstrapForm.Group className="GraphDisplaySettings__FormGroup">
        <BootstrapForm.Label className="GraphDisplaySettings__FormLabel">Maximum Slices</BootstrapForm.Label>
        <div className="GraphDisplaySettings__InputSmall">
          <BootstrapForm.Control
            value={maxPieSlices}
            type="number"
            onChange={(event: SyntheticEvent) => {
              const eventTarget = event.target as HTMLInputElement;
              setMaxPieSlices(eventTarget.valueAsNumber || K.DEFAULT_MAX_PIE_SLICES);
            }}
            size="sm"
          />
        </div>
      </BootstrapForm.Group>
    </div>
  );
}

export default PieSettingsMenu;
